// WO-2912: the active partner's identity in the page header. Renders partners.logo_url as stored; the letter badge appears only when the partner has no logo (or the file cannot load).
import React, { useEffect, useState } from 'react';
import { sizedLogoUrl } from '../lib/logoUrl';

export const partnerLogoSource = (partner) => partner?.logo_url || '';

export default function PartnerHeaderLogo({ partner, isMobile = false }) {
  const source = partnerLogoSource(partner);
  const [stage, setStage] = useState(0); // 0 resized copy, 1 original file, 2 failed -> badge
  useEffect(() => { setStage(0); }, [partner?.id, source]);
  if (!partner) return null;
  const showImage = !!source && stage < 2;
  const brand = partner.brand_color || 'var(--gov-accent-slate)';
  return (
    <div data-testid="partner-header-identity" data-partner-id={partner.id} style={{ display: 'flex', alignItems: 'center', flexShrink: 0, minWidth: 0 }}>
      {showImage ? (
        <img
          data-testid="partner-header-logo"
          src={stage === 0 ? sizedLogoUrl(source) : source}
          alt={partner.name}
          fetchpriority="low"
          decoding="async"
          onError={() => setStage((s) => (s === 0 && sizedLogoUrl(source) !== source ? 1 : 2))}
          style={{ maxHeight: 36, maxWidth: isMobile ? 96 : 150, objectFit: 'contain' }}
        />
      ) : (
        <span data-testid="partner-header-badge" title={partner.name} style={{ width: 32, height: 32, borderRadius: 8, background: brand, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 800 }}>
          {(partner.name || '?').trim()[0].toUpperCase()}
        </span>
      )}
    </div>
  );
}
